export default {
  courierPropList: '/prop/client/courierPropList'
}
